/* eslint-disable @next/next/no-img-element */
// components/article-content/ArticleContent.tsx
'use client';

import { useState, useEffect } from 'react';
import Image from 'next/image';

interface LightboxProps {
    src: string;
    alt: string;
    onClose: () => void;
}

const Lightbox = ({ src, alt, onClose }: LightboxProps) => {
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/80"
            onClick={onClose}
        >
            <div className="relative max-h-[90vh] max-w-[90vw]">
                <button
                    className="absolute -top-10 right-0 text-white hover:text-gray-300"
                    onClick={onClose}
                >
                    x
                </button>
                <img
                    src={src}
                    alt={alt}
                    className="max-h-[85vh] max-w-[85vw] object-contain"
                />
            </div>
        </div>
    );
};

export default function ArticleContent({ content }: { content: string }) {
    const [lightboxImage, setLightboxImage] = useState<{ src: string; alt: string } | null>(null);
    const [processedContent, setProcessedContent] = useState(content);

    useEffect(() => {
        const processContent = () => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(content, 'text/html');

            // Find all images in the content
            const images = doc.getElementsByTagName('img');

            for (const img of Array.from(images)) {
                // Create a wrapper div
                const wrapper = doc.createElement('div');
                wrapper.className = 'cursor-pointer';
                wrapper.setAttribute('data-image-src', img.src);
                wrapper.setAttribute('data-image-alt', img.alt);

                // Clone the image and wrap it
                const imgClone = img.cloneNode(true) as HTMLImageElement;
                wrapper.appendChild(imgClone);

                // Replace original image with wrapper
                img.parentNode?.replaceChild(wrapper, img);
            }

            return doc.body.innerHTML;
        };

        // Only process content in the browser
        if (typeof window !== 'undefined') {
            setProcessedContent(processContent());
        }
    }, [content]);

    const handleImageClick = (event: React.MouseEvent) => {
        const target = event.target as HTMLElement;
        const wrapper = target.closest('[data-image-src]');

        if (wrapper) {
            const src = wrapper.getAttribute('data-image-src');
            const alt = wrapper.getAttribute('data-image-alt');
            if (src) {
                setLightboxImage({ src, alt: alt ?? '' });
            }
        }
    };

    return (
        <>
            <article
                className="post-content prose prose-lg mx-auto max-w-[50rem] dark:prose-invert prose-headings:text-foreground"
                dangerouslySetInnerHTML={{ __html: processedContent }}
                onClick={handleImageClick}
            />

            {lightboxImage && (
                <Lightbox
                    src={lightboxImage.src}
                    alt={lightboxImage.alt}
                    onClose={() => setLightboxImage(null)}
                />
            )}
        </>
    );
}














// /* eslint-disable @next/next/no-img-element */
// // components/article-content/ArticleContent.tsx
// 'use client';

// import { useState } from 'react';
// import Image from 'next/image';

// interface LightboxProps {
//     src: string;
//     alt: string;
//     onClose: () => void;
// }

// const Lightbox = ({ src, alt, onClose }: LightboxProps) => {
//     return (
//         <div
//             className="fixed inset-0 z-50 flex items-center justify-center bg-black/80"
//             onClick={onClose}
//         >
//             <div className="relative max-h-[90vh] max-w-[90vw]">
//                 <button
//                     className="absolute -top-10 right-0 text-white hover:text-gray-300"
//                     onClick={onClose}
//                 >
//                     x
//                 </button>
//                 {/* Use a regular img tag here as Next.js Image has limitations with dynamic URLs */}
//                 <img
//                     src={src}
//                     alt={alt}
//                     className="max-h-[85vh] max-w-[85vw] object-contain"
//                 />
//             </div>
//         </div>
//     );
// };

// export default function ArticleContent({ content }: { content: string }) {
//     const [lightboxImage, setLightboxImage] = useState<{ src: string; alt: string } | null>(null);

//     // Process content to make images clickable
//     const processContent = () => {
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(content, 'text/html');

//         // Find all images in the content
//         const images = doc.getElementsByTagName('img');

//         for (const img of Array.from(images)) {
//             // Create a wrapper div
//             const wrapper = doc.createElement('div');
//             wrapper.className = 'cursor-pointer';
//             wrapper.setAttribute('data-image-src', img.src);
//             wrapper.setAttribute('data-image-alt', img.alt);

//             // Clone the image and wrap it
//             const imgClone = img.cloneNode(true) as HTMLImageElement;
//             wrapper.appendChild(imgClone);

//             // Replace original image with wrapper
//             img.parentNode?.replaceChild(wrapper, img);
//         }

//         return doc.body.innerHTML;
//     };

//     const handleImageClick = (event: React.MouseEvent) => {
//         const target = event.target as HTMLElement;
//         const wrapper = target.closest('[data-image-src]');

//         if (wrapper) {
//             const src = wrapper.getAttribute('data-image-src');
//             const alt = wrapper.getAttribute('data-image-alt');
//             if (src) {
//                 setLightboxImage({ src, alt: alt ?? '' });
//             }
//         }
//     };

//     return (
//         <>
//             <article
//                 className="post-content prose prose-lg mx-auto max-w-[50rem] dark:prose-invert prose-headings:text-foreground"
//                 dangerouslySetInnerHTML={{ __html: processContent() }}
//                 onClick={handleImageClick}
//             />

//             {lightboxImage && (
//                 <Lightbox
//                     src={lightboxImage.src}
//                     alt={lightboxImage.alt}
//                     onClose={() => setLightboxImage(null)}
//                 />
//             )}
//         </>
//     );
// }